export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "imgCompress": {
    "title": "图片压缩工具",
    "subtitle": "在线压缩 JPEG、PNG、WebP 图片。",
    "privacy": "100% 本地处理",
    "noUpload": "无需上传",
    "uploadTitle": "上传图片",
    "uploadDesc": "拖拽或点击选择。支持 JPEG、PNG、WebP、GIF。",
    "addFiles": "添加图片",
    "files": "文件",
    "quality": "质量",
    "qualityDesc": "越高画质越好，文件越大",
    "maxWidth": "最大宽度",
    "widthDesc": "超出此尺寸的图片将被缩放",
    "format": "输出格式",
    "original": "原始格式",
    "compress": "全部压缩",
    "processing": "正在处理...",
    "invalidFile": "请选择图片文件（JPEG、PNG、WebP、GIF）"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有图片压缩均通过浏览器 Canvas API 在本地完成。您的照片和图片绝不会上传到任何服务器，确保视觉内容的完全隐私。"
    },
    "guide": {
      "title": "如何使用图片压缩工具",
      "description": "在不离开浏览器的情况下减小图片文件体积，适用于更快的网站加载、社交媒体上传和邮件附件。",
      "steps": [
        {
          "title": "上传图片",
          "description": "将一张或多张图片（JPG、PNG、WebP、GIF）拖放到上传区域，也可以点击浏览文件。上传后立即开始处理。"
        },
        {
          "title": "设置压缩级别",
          "description": "使用质量滑块在文件大小和视觉质量之间取得平衡。实时预览会显示压缩前后的对比效果。"
        },
        {
          "title": "下载压缩文件",
          "description": "对预览效果满意后，点击下载即可将优化后的图片保存到设备。高分辨率照片通常可缩减 50–90% 的文件大小。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "支持 JPG、PNG、WebP 和 GIF 格式的客户端压缩",
        "可调节质量滑块，附带实时前后对比预览",
        "支持多张图片的批量处理",
        "保持原始尺寸的同时优化文件大小",
        "照片和截图通常可缩减 50–90% 体积",
        "无需服务器上传 — 图片始终保留在您的设备上"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "压缩会降低图片质量吗？",
          "answer": "较低设置下确实会有一定质量损失，但滑块让您能找到最佳平衡点。对于网页用途，70–85% 的质量通常能产生明显更小且几乎看不出质量差异的文件。"
        },
        {
          "question": "支持哪些图片格式？",
          "answer": "本工具支持 JPG、PNG、WebP 和 GIF。默认输出格式与输入一致。对于照片，WebP 通常能提供最佳的压缩率。"
        },
        {
          "question": "有文件大小限制吗？",
          "answer": "没有服务器端限制。唯一限制是浏览器内存。大多数现代设备可以处理高达 20–50 MB 的图片而不会出现任何问题。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "图片尺寸调整",
          "url": "/image/image-resizer",
          "description": "将图片精确调整到社交媒体和网页所需的尺寸。"
        },
        {
          "name": "图片格式转换",
          "url": "/image/image-converter",
          "description": "在 JPG、PNG、WebP 等图片格式之间转换。"
        },
        {
          "name": "图片水印工具",
          "url": "/image/image-watermarker",
          "description": "添加文字或 Logo 水印以保护您的图片。"
        }
      ]
    }
  }
};
